import axiosInstance from '@/utils/api.js'

var state = {
  ISGprofile: []
}

var getters = {
  ISG_PROFILE: (state) => {
    return state.ISGprofile
  }
}

var mutations = {
  SET_ISG_PROFILE: (state, payload) => {
    state.ISGprofile = payload
  }
}

var actions = {
  GET_ISG_PROFILE: async (context, payload) => {
    let result = await axiosInstance.get('/settings/isg_profiles')
    if (result.status === 200) {
      context.commit('SET_ISG_PROFILE', result.data)
    }
  },
  CREATE_ISG_PROFILE: (context, payload) => {
    return axiosInstance.post('/settings/isg_profiles', payload)
  },
  UPDATE_ISG_PROFILE: (context, payload) => {
    return axiosInstance.put('/settings/isg_profiles', payload)
  },
  DELETE_ISG_PROFILE: (context, payload) => {
    return axiosInstance.delete('/settings/isg_profiles?isg_profile_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/ISGprofile.js